import { InvalidValueException } from "@shared/utils";

import { TFunction } from "i18next";
import { t_warningTexts } from "@i18n/usualTexts/t_warningTexts";

const ANTI_BOT_ERROR_TITLES = ["AntiBotTokenMissingError", "AntiBotInvalidTokenError"];

interface RegisterErrorHandler {
  matches: (error: any) => boolean;
  handle: (
    error: any,
    setServerErrorPopUp: React.Dispatch<React.SetStateAction<string | null>>,
    frontExceptionFunction: Function,
    t: TFunction<"translation", undefined>
  ) => void;
}

const registerErrorHandlers: RegisterErrorHandler[] = [
  {
    matches: (error) => !!error.description,
    handle: (error, _setPopUp, frontExceptionFn) =>
      frontExceptionFn((error as InvalidValueException).description),
  },
  {
    matches: (error) => error.body?.title === "UsernameAlreadyExistsError",
    handle: (_error, _setPopUp, frontExceptionFn, t) =>
      frontExceptionFn(["username", t(t_warningTexts.signup.usernameAlreadyExistsError)]),
  },
  {
    matches: (error) => error.body?.title === "InvalidConfirmationCodeError",
    handle: (_error, _setPopUp, frontExceptionFn, t) =>
      frontExceptionFn(["usernamecode", t(t_warningTexts.signup.code)]),
  },
  {
    matches: (error) => !!error.body?.exception_uuid,
    handle: (error, setPopUp) =>
      setPopUp(error.body.exception_uuid),
  },
  {
    matches: (error) => ANTI_BOT_ERROR_TITLES.includes(error.body?.title),
    handle: (error, setPopUp, _frontExceptionFn, t) => {
      const key = error.body.title === "AntiBotTokenMissingError"
        ? "error.antiBot.MissingTokenError"
        : "error.antiBot.InvalidTokenError";
      setPopUp(t(key));
    },
  },
  {
    matches: (error) => !!error.body,
    handle: (error, setPopUp) =>
      setPopUp(error.body.title),
  },
  {
    matches: (error) => !!error.message,
    handle: (error, setPopUp) =>
      setPopUp(error.message),
  },
];

export function showAuthError(
  error: any,
  setServerErrorPopUp: React.Dispatch<React.SetStateAction<string | null>>,
  frontExceptionFunction: Function,
  t: TFunction<"translation", undefined>
) {
  console.log(error);

  const handler = registerErrorHandlers.find((h) => h.matches(error));
  handler?.handle(error, setServerErrorPopUp, frontExceptionFunction, t);
}
